<template>
  <div class="card card-floating-boxed card-shadow">
    <div class="card-image">
      <a :href="`/event/${event.url}`">
        <figure class="image is-4by3">
          <img class="lazy event-img" :src="`${event.imgUrl}`" alt="" />
        </figure>
      </a>
    </div>
    <div class="card-content">
      <div class="media">
        <div class="media-content">
          <a class="title is-4 color-accent" :href="`/event/${event.url}`">{{
            event.eventname
          }}</a>
          <p class="subtitle">
            {{ eventType }}
          </p>
          <p class="subtitle" style="margin-top: 10px !important">
            <i class="fa fa-calendar"></i> {{ event.eventdate | date }} -
            {{ event.eventenddate | date }}
          </p>
          <p v-if="entry.dependant" class="m-t-xs">
            <strong>Dependant Entry:</strong> {{ entry.dependant.firstname }}
            {{ entry.dependant.surname }}
          </p>
          <p v-if="entry.entrytype == 'Team'" class="m-t-xs">
            <strong>Your Team Name:</strong> {{ entry.teamname }}
          </p>
          <p v-if="entry.entrytype == 'Team'" class="m-t-xs">
            <strong>Category:</strong> {{ entry.category }}
          </p>
          <p v-if="entry.teammember" class="m-t-xs">
            <strong>Your Team Name:</strong> {{ entry.evententry.teamname }}
          </p>
          <p v-if="entry.teammember" class="m-t-xs">
            <strong>Category:</strong> {{ entry.evententry.category }}
          </p>

          <p v-if="!entry.paid && !entry.teammember" class="has-text-danger">
            Payment Outstanding
          </p>
          <p
            v-if="
              entry.affiliateteam && event.config && event.config.affiliateteams
            "
            class="m-t-xs"
          >
            <strong>Affiliate Team: </strong> {{ entry.affiliateteam.name }}
          </p>
          <p
            v-if="entry.teammember || entry.entrytype == 'Team'"
            class="m-t-xs"
          >
            <strong
              >Waiver Status:
              <span
                v-if="entry.teammember && !entry.acceptwaiver"
                class="is-danger"
                >Not Signed </span
              ><span
                v-if="
                  (entry.teammember && entry.acceptwaiver) ||
                  entry.entrytype == 'Team'
                "
                class="is-success"
                >Signed</span
              ></strong
            >
          </p>
        </div>
      </div>

      <div class="content"></div>
      <div class="has-text-centered">
        <div
          class="button btn-align has-icon-right primary-btn btn-outlined is-drop is-centered"
        >
          Actions <i class="sl sl-icon-arrow-down is-icon-xs"></i>
          <div class="dropContain">
            <div class="dropOut">
              <ul>
                <li v-if="!entry.paid && !entry.teammember">
                  <router-link
                    :to="{ name: 'PayForEvent', params: { id: entry._id } }"
                    >Pay Now</router-link
                  >
                </li>
                <li
                  v-if="entry.paid && entry.prepaid && !entry.prepaidcomplete"
                >
                  <router-link
                    :to="{ name: 'CompleteEntry', params: { id: entry._id } }"
                    >Complete Entry</router-link
                  >
                </li>
                <li
                  v-if="
                    entry.paid &&
                    event.allowcapturescore &&
                    !(
                      entry.entrytype == 'Team' &&
                      event.config.groupedteams &&
                      event.config
                    ) &&
                    event.type == 'online'
                  "
                >
                  <router-link
                    v-if="event.config.allowmultipleentries"
                    :to="{
                      name: 'CaptureScoreEventEntry',
                      params: { id: event._id, evententry: entry._id },
                    }"
                    >Capture Score</router-link
                  >
                  <router-link
                    v-else
                    :to="{
                      name: 'CaptureScore',
                      params: { id: event._id },
                    }"
                    >Capture Score</router-link
                  >
                </li>
                <li><a :href="`/event/${event.url}`">View Event</a></li>
                <li
                  v-if="
                    entry.entrytype == 'Team' &&
                    event.config &&
                    !event.config.hidemanageteam
                  "
                >
                  <router-link
                    :to="{
                      name: event.config.groupedteams
                        ? 'ManageGroupedTeam'
                        : 'ManageTeam',
                      params: { id: entry._id },
                    }"
                    >Pick your team mates</router-link
                  >
                </li>
                <li
                  v-if="
                    entry.entrytype == 'Team' &&
                    !(event.config && event.config.groupedteams) &&
                    !(event.config && event.config.lockchanges)
                  "
                >
                  <a href="" @click.prevent="changeCaptaincy(entry)"
                    >Change Captaincy</a
                  >
                </li>
                <li
                  v-if="
                    entry.teammember &&
                    event.config &&
                    !event.config.hideviewteam
                  "
                >
                  <router-link
                    :to="{
                      name: 'ViewTeam',
                      params: { id: entry.evententry._id },
                    }"
                    >View Your Team</router-link
                  >
                </li>
                <li
                  v-if="
                    entry.teammember &&
                    entry.acceptwaiver == false &&
                    event.config &&
                    !event.config.hidefinalize &&
                    !event.config.lockchanges
                  "
                >
                  <router-link
                    :to="{
                      name: 'TeamMemberFinalize',
                      params: { id: event._id },
                    }"
                    >Sign Waiver and Finalize Entry</router-link
                  >
                </li>
                <li v-if="event.showentries">
                  <a :href="`/view-entries/${event.url}`">See Who Entered</a>
                </li>
                <li v-if="event.showleaderboard">
                  <a :href="`/leaderboard/${event.url}`">Leaderboard</a>
                </li>
                <li v-if="event.showheats">
                  <a :href="`/heats/${event.url}`">Heats</a>
                </li>
                <li v-if="event.config && event.config.showschedule">
                  <a :href="`/schedule/${event.url}`">Schedule</a>
                </li>
                <li v-if="event.config && event.config.showusersworkouts">
                  <router-link
                    v-if="entry.teammember"
                    :to="{
                      name: 'ViewWorkouts',
                      params: { id: entry.evententry._id },
                    }"
                    >Workouts</router-link
                  >
                  <router-link
                    v-else
                    :to="{ name: 'ViewWorkouts', params: { id: entry._id } }"
                    >Workouts</router-link
                  >
                </li>
                <li v-if="event.config && event.config.menuitems">
                  <a
                    :href="item.url"
                    v-for="item in event.config.menuitems"
                    :key="item.label"
                    >{{ item.label }}</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      :active.sync="showChangeCaptaincyModal"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Change Captaincy</p>
        </header>
        <section class="modal-card-body">
          To change your team's captain, please send the new captain the
          following link:<br /><a
            :href="`https://www.capturefit.co.za/app-v2/change-captaincy/${showChangeCaptaincyEntryId}`"
            ><strong
              >https://capturefit.com/app-v2/change-captaincy/{{
                showChangeCaptaincyEntryId
              }}</strong
            ></a
          >
        </section>
        <footer class="modal-card-foot">
          <button
            class="button"
            type="button"
            @click="showChangeCaptaincyModal = false"
          >
            Close
          </button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import filters from "@/filters";

export default {
  mixins: [filters],
  props: {
    user: {
      type: Object,
      default: null,
    },
    entry: {
      type: Object,
      default: null,
    },
    event: {
      type: Object,
      default: null,
    },
  },
  computed: {
    eventType() {
      if (
        this.event &&
        this.event.entrytypes &&
        this.event.entrytypes.length > 1
      ) {
        return `Team / Individual - ${this.event.city || "Online"}`;
      } else if (
        this.event &&
        this.event.entrytypes &&
        this.event.entrytypes.length === 1
      ) {
        return `${this.event.entrytypes[0]} - ${this.event.city || "Online"}`;
      }
      return "";
    },
  },
  data() {
    return {
      showChangeCaptaincyModal: false,
      showChangeCaptaincyEntryId: {},
    };
  },
  methods: {
    changeCaptaincy(entry) {
      this.showChangeCaptaincyModal = true;
      this.showChangeCaptaincyEntryId = entry._id;
    },
  },
};
</script>

<style scoped>
.dropOut ul li {
  white-space: normal;
  font-size: 0.85em;
}
</style>